import { render, staticRenderFns } from "./HeaderAccount.vue?vue&type=template&id=10b43aaf&scoped=true&"
import script from "./HeaderAccount.vue?vue&type=script&lang=js&"
export * from "./HeaderAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b43aaf",
  null
  
)

export default component.exports